import { usePlatformLogo } from "@shared/hooks/usePlatformLogo";
import defaultLogo from "@/assets/logo.svg";
import defaultLogoTransparent from "@/assets/logo-transparent.svg";

interface PlatformLogoProps {
  variant?: "main" | "transparent";
  className?: string;
  alt?: string;
}

export const PlatformLogo = ({ 
  variant = "main", 
  className = "h-12 w-auto object-contain",
  alt = "DietiTech"
}: PlatformLogoProps) => {
  const { logoUrl, transparentLogoUrl } = usePlatformLogo();

  // Use database URLs if available, otherwise fall back to defaults
  const src = variant === "main" 
    ? (logoUrl || defaultLogo)
    : (transparentLogoUrl || defaultLogoTransparent);

  return (
    <img 
      src={src} 
      alt={alt} 
      className={className}
    />
  );
};
